import api from '@api/endpoints';
import { getErrorMessage } from '@utils';
import { GOMS_FULFILLMENT_CONSTANTS as types } from '@store/constants';
import { setAlert } from '@store/actions/alertActions';
import { ALERT_STATUS_TYPE } from '@constants';
import { gomsOrderDashboardConfigBuilder } from '@views/GomsOrderDashboard/utils';


export const getDashboardConfig = () => async (dispatch) => {
  try {
    dispatch({
      type: types.GETTING_GOMS_CONFIG
    });

    const data = gomsOrderDashboardConfigBuilder();

    dispatch({
      type: types.GET_GOMS_CONFIG_SUCCESS,
      payload: data
    });

  } catch (error) {
    dispatch(
      setAlert({
        title: getErrorMessage({
          error,
          genericMessage: 'Failed to get Goms config'
        }),
        status: ALERT_STATUS_TYPE.ERROR
      })
    );
  }
};

export const getGomsOnHoldFulfillments = ({ payload, onSuccess, onComplete }) => async (dispatch) => {
  try {
    dispatch({
      type: types.GETTING_GOMS_ON_HOLD_FULFILLMENTS,
      payload: payload
    });

    const { data } = await api.gomsFulfillment.getAllFulfillment(payload);

    // NOTE :: Only adding total page and result in the redux store
    const { result, totalPage } = data;

    dispatch({
      type: types.GET_GOMS_ON_HOLD_FULFILLMENTS_SUCCESS,
      payload: {
        result,
        totalPage
      }
    });

    onSuccess && onSuccess(data);

  } catch (error) {
    dispatch(
      setAlert({
        title: 'Failed to get goms on hold fulfillments',
        status: ALERT_STATUS_TYPE.ERROR
      })
    );

    dispatch({
      type: types.GET_GOMS_ON_HOLD_FULFILLMENTS_FAILURE,
      payload: error?.message
    });
  } finally {
    onComplete && onComplete();
  }
};

export const getGomsFulfillmentById = ({ fulfillmentId }) => async (dispatch) => {
  try {
    dispatch({
      type: types.GETTING_GOMS_FULFILLMENT_BY_ID,
      payload: { fulfillmentId }
    });

    const { data } = await api.gomsFulfillment.getFulfillmentById({ fulfillmentId });
    dispatch({
      type: types.GET_GOMS_FULFILLMENT_BY_ID_SUCCESS,
      payload: data
    });
  } catch (error) {
    dispatch(
      setAlert({
        title: getErrorMessage({
          error,
          genericMessage: 'Failed to get Goms fulfillment details'
        }),
        status: ALERT_STATUS_TYPE.ERROR
      })
    );
    dispatch({
      type: types.GET_GOMS_FULFILLMENT_BY_ID_FAILURE,
      payload: {
        message: error?.message || 'Failed to get Goms fulfillment details',
        code: error?.code || 'UNKNOWN_ERROR'
      }
    });
  }
};

export const forceInitiateGomsFulfillment =
  ({ fulfillmentId, onSuccess, onComplete }) =>
    async (dispatch) => {
      try {
        dispatch({
          type: types.FORCE_INITIATING_GOMS_FULFILLMENT
        });

        await api.gomsFulfillment.forceInitiateFulfillment({ fulfillmentId });

        if (onSuccess) onSuccess();

        dispatch(
          setAlert({
            title: 'Force initiated fulfillment: ' + fulfillmentId,
            status: ALERT_STATUS_TYPE.SUCCESS
          })
        );

        dispatch({
          type: types.FORCE_INITIATE_GOMS_FULFILLMENT_SUCCESS
        });
      } catch (error) {
        dispatch(
          setAlert({
            title: getErrorMessage({
              error,
              genericMessage: 'Failed to force initiate Goms fulfillment'
            }),
            status: ALERT_STATUS_TYPE.ERROR
          })
        );

        dispatch({
          type: types.FORCE_INITIATE_GOMS_FULFILLMENT_FAILURE,
          payload: {
            message: error?.message || 'Failed to force initiate Goms fulfillment',
            code: error?.code || 'UNKNOWN_ERROR'
          }
        });
      } finally {
        if (onComplete) onComplete();
      }
    };